'use client'

import Button from '@/components/ui/Button'
import { signOut } from 'next-auth/react'

const UserSettings = () => {
  return (
    <div className='flex flex-col gap-4 items-center justify-center mt-10'>
      <Button
        onClick={() => {
          signOut({ callbackUrl: '/chat?login=true' })
        }}
      >
        Sign out
      </Button>
    </div>
  )
}

export default UserSettings
